import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const faqItems: FAQItem[] = [
    {
      question: "What services does NOPRBLM offer?",
      answer: "NOPRBLM offers a comprehensive range of creative and tech services including branding, digital design, creative direction, virtual experiences, event activations, and brand strategy. We work with clients across various industries to provide tailored solutions that meet their specific needs."
    },
    {
      question: "How do I start a project with NOPRBLM?",
      answer: "Starting a project with us is simple. Fill out the contact form with details about your project, and our team will get back to you within 24-48 hours to discuss your requirements, timeline, and budget. We'll guide you through our collaborative process from initial concept to final delivery."
    },
    {
      question: "Do you work with clients internationally?",
      answer: "Yes, we work with clients globally. Our team is based in London, but we have experience collaborating with brands and creators worldwide. We've perfected our remote working systems to ensure smooth communication and project management regardless of location."
    },
    {
      question: "What is your typical project timeline?",
      answer: "Project timelines vary depending on scope and complexity. Small projects might take 2-4 weeks, while larger ones can span several months. During our initial consultation, we'll provide a customized timeline based on your specific requirements and objectives."
    },
    {
      question: "How do you charge for your services?",
      answer: "We offer both project-based and retainer pricing models. Project-based pricing is ideal for one-time initiatives with clear deliverables, while retainers work well for ongoing collaborations. We provide transparent pricing based on project scope, complexity, and timeline."
    }
  ];

  const toggleExpanded = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2>Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqItems.map((item, index) => (
          <div key={index} className={`faq-item ${expandedIndex === index ? 'expanded' : ''}`}>
            <div 
              className="faq-question" 
              onClick={() => toggleExpanded(index)}
            >
              <h3>{item.question}</h3>
              <span className="faq-toggle">{expandedIndex === index ? '−' : '+'}</span>
            </div>
            <div className="faq-answer" style={{ maxHeight: expandedIndex === index ? '1000px' : '0' }}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;